import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionService {
  readonly expired = signal(false);

  markExpired(): void { this.expired.set(true); }
  clear(): void { this.expired.set(false); }
}
